import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=649d25fe&scoped=true&"
import script from "./Redirect.vue?vue&type=script&lang=ts&"
export * from "./Redirect.vue?vue&type=script&lang=ts&"
import style0 from "./Redirect.vue?vue&type=style&index=0&id=649d25fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d25fe",
  null
  
)

export default component.exports